module.exports = __webpack_public_path__ + "static/img/14000536.312d3bfd.png";